export default "<div class=\"spinner-overlay\" *ngIf=\"spinnerService.loading$ | async\">\r\n  <div class=\"spinner\"></div>\r\n</div>\r\n";